// components/BlogCarousel.jsx
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { ProCard } from "@ant-design/pro-components";
import { Typography, Tag } from "antd";
import React, { useRef } from "react";

const { Title, Text } = Typography;

const Swiper = ({ heading, cards }) => {
  const containerRef = useRef(null);

  const scroll = (direction) => {
    if (!containerRef.current) return;
    const scrollAmount = 300;
    containerRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div style={{ position: "relative", margin: "3rem 0" }}>
      <Title level={4} style={{ margin: "0 40px 1rem" }}>
        {heading}
      </Title>

      <LeftOutlined
        onClick={() => scroll("left")}
        style={{
          position: "absolute",
          left: 0,
          top: "55%",
          transform: "translateY(-50%)",
          fontSize: 20,
          zIndex: 2,
          cursor: "pointer",
        }}
      />
      <RightOutlined
        onClick={() => scroll("right")}
        style={{
          position: "absolute",
          right: 0,
          top: "55%",
          transform: "translateY(-50%)",
          fontSize: 20,
          zIndex: 2,
          cursor: "pointer",
        }}
      />

      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          gap: 16,
          padding: "0 40px",
        }}
      >
        {cards.map((card, index) => (
          <ProCard
            key={index}
            style={{ minWidth: 280 }}
            bordered
            onClick={() => window.open(`/blog/sample-${index + 1}`, "_blank")}
            bodyStyle={{ padding: 16 }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              {card.title}
            </Title>
            <Text type="secondary">
              Last updated: {new Date(card.lastUpdated).toDateString()}
            </Text>

            <div style={{ marginTop: 12 }}>
              <Text strong style={{ display: "block", marginBottom: 4 }}>
                Companies mentioned:
              </Text>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {card.companies.map((c) => (
                  <Tag key={c} color="blue">
                    {c}
                  </Tag>
                ))}
              </div>
            </div>
          </ProCard>
        ))}
      </div>
    </div>
  );
};

export default Swiper;
